import { maskCep } from "../../../utils/mask";
import { maskCpfCnpj } from "../../../utils/mask";
import { maskMoney } from "../../../utils/mask";
import { IProponente } from "../types/proposta";
import { formatDate } from "./propostaMappers";

export type PortalClientResponse = {
  id_cliente?: number;
  pessoaid?: number;
  nome?: string;
  cpfcnpj?: string;
  rg?: string;
  emissor_rg?: string;
  datanascimento?: string;
  naturalidade?: string;
  nacionalidade?: string;
  estadocivil?: string | number;
  telefone?: string;
  telefone_01?: string;
  telefone_02?: string;
  cod_pais?: string;
  codPais?: string;
  email?: string;
  profissao?: string;
  renda_mensal?: string | number;
  observacao?: string;
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  codibge?: string;
};

const ESTADO_CIVIL_MAP: Record<string, string> = {
  "1": "s",
  "2": "c",
  "3": "d",
  "4": "v",
  "5": "d",
  "6": "u",
};

export function mapEstadoCivilFromApi(value?: string | number | null): string {
  if (value == null || value === "") return "";
  const key = `${value}`;
  if (ESTADO_CIVIL_MAP[key]) return ESTADO_CIVIL_MAP[key];
  return key;
}

function resolveClientPhone(data: PortalClientResponse): {
  telefone: string;
  cod_pais?: string;
} {
  const telefone = [data.telefone, data.telefone_01, data.telefone_02]
    .map((v) => (v != null ? String(v).trim() : ""))
    .find(Boolean);

  return {
    telefone: telefone ? telefone.replace(/\D/g, "") : "",
    cod_pais: data.cod_pais ?? data.codPais,
  };
}

export function mapPortalClientToProponenteFields(
  data: PortalClientResponse,
  cpfCnpjMasked: string,
): Partial<IProponente> & { id_cliente?: number; id_pessoa?: number } {
  const phone = resolveClientPhone(data);
  const estadoCivil = mapEstadoCivilFromApi(data.estadocivil);

  return {
    id_cliente: data.id_cliente,
    id_pessoa: data.pessoaid,
    nome: data.nome ?? "",
    cpfCnpj: data.cpfcnpj ? maskCpfCnpj(data.cpfcnpj) : cpfCnpjMasked,
    rg: data.rg ?? "",
    emissorRG: data.emissor_rg ?? "",
    dataNascimento: data.datanascimento
      ? formatDate(new Date(data.datanascimento))
      : "",
    naturalidade: data.naturalidade ?? "",
    nacionalidade: data.nacionalidade ?? "",
    estadoCivil,
    telefone: phone.telefone,
    cod_pais: phone.cod_pais ?? "+55",
    email: data.email ?? "",
    profissao: data.profissao ?? "",
    rendaMensal: data.renda_mensal
      ? maskMoney(String(Math.round(Number(data.renda_mensal) * 100)))
      : "",
    observacoes: data.observacao ?? "",
    cep: data.cep ? maskCep(data.cep) : "",
    logradouro: data.logradouro ?? "",
    numero: data.numero ? `${data.numero}` : "",
    complemento: data.complemento ?? "",
    bairro: data.bairro ?? "",
    cidade: data.cidade ?? "",
    estado: data.estado ?? "",
    codibge: data.codibge ?? "",
  };
}
